<template>
  <div class="row">
    <div class="col-12">
      <div class="alert alert-warning text-center h3" role="alert">
        Your box has
        <u>2 meals</u> for
        <u>2 people</u> and will be delivered on
        <u>Sunday 3rd March</u>
      </div>
    </div>
    <FormInput
      label="Address 1"
      name="address_1"
      :required="true"
      autocomplete="address-line1"
      placeholder="e.g. 31 Sun Street"
      @input="update"
      v-model="value.address1"
    ></FormInput>
    <FormInput
      label="Address 2"
      name="address_2"
      autocomplete="address-line2"
      placeholder="e.g. Stratford"
      @input="update"
      v-model="value.address2"
    ></FormInput>
    <FormInput
      label="Town"
      name="town"
      autocomplete="address-level2"
      placeholder="e.g. London"
      :required="true"
      @input="update"
      v-model="value.city"
    ></FormInput>
    <FormInput
      pattern="^(([gG][iI][rR] {0,}0[aA]{2})|((([a-pr-uwyzA-PR-UWYZ][a-hk-yA-HK-Y]?[0-9][0-9]?)|(([a-pr-uwyzA-PR-UWYZ][0-9][a-hjkstuwA-HJKSTUW])|([a-pr-uwyzA-PR-UWYZ][a-hk-yA-HK-Y][0-9][abehmnprv-yABEHMNPRV-Y]))) {0,}[0-9][abd-hjlnp-uw-zABD-HJLNP-UW-Z]{2}))$"
      label="Postcode"
      name="postal"
      :required="true"
      autocomplete="postal-code"
      placeholder="e.g. E14 2JW"
      @input="update"
      v-model="value.postcode"
    >
      <AddressList
        label="Lookup address from postcode"
        :postcode="value.postcode"
        v-model="addressItems"
      ></AddressList>
    </FormInput>
    <FormInput
      pattern="((\+44\s?\(0\)\s?\d{2,4})|(\+44\s?(01|02|03|07|08)\d{2,3})|(\+44\s?(1|2|3|7|8)\d{2,3})|(\(\+44\)\s?\d{3,4})|(\(\d{5}\))|((01|02|03|07|08)\d{2,3})|(\d{5}))(\s|-|.)(((\d{3,4})(\s|-)(\d{3,4}))|((\d{6,7})))"
      label="Telephone"
      name="town"
      autocomplete="tel"
      placeholder="e.g. 0773476284"
      @input="update"
      v-model="value.tel"
    ></FormInput>
    <TextInput
      label="Delivery Notes"
      :linecount="4"
      name="town"
      placeholder="Anything special to tell us about where to leave you order?"
      @input="update"
      v-model="value.notes"
    ></TextInput>
  </div>
</template>
<script>
import FormInput from "@/components/form/FormInput";
import TextInput from "@/components/form/TextInput";
import AddressList from "@/components/cart/AddressList";
import { mapState } from "vuex";

export default {
  components: { FormInput, TextInput, AddressList },
  props: ["value"],
  methods: {
    update: function() {
      this.$emit("input", this.$props.value);
    }
  },
  computed: {
    ...mapState({
      addressItems: state => state.address.items
    })
  }
};
</script>
